<script setup lang="ts">
import type { CmsElementReviewsBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementReviewsBox;
  class: any;
  style: any;
}>();

const { heading, iconWithText } = props.content?.config

</script>
<template>
  <section class="section section-main section-testimonials--alt" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{$t('trustedshops.review.headline')}}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">

        <div class="trustedShopsReviewBox">
          <etrusted-widget data-etrusted-widget-id="wdg-6bab3099-2625-4c82-95e5-5833dd16e46a"></etrusted-widget>
        </div>
      </div>
    </div>
  </section>
</template>